import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: auto;
    display: flex;
    flex-direction: column;
`;

export const CardWrapper = styled.div`
    display: flex;
    align-items: center;
    background: ${props => props.theme.colours.textWhite};
    padding: 16px;
`;

export const Badge = styled.img`
    width: 48px;
    height: 48px;
    margin-right: 16px;
    object-fit: contain;
`;

export const TeamName = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large};
    color: ${props => props.theme.colours.textDark};
`;
